/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AccountsRequestBuilderNavigationMetadata, AccountsRequestBuilderRequestsMetadata, type AccountsRequestBuilder } from './accounts/index.js';
// @ts-ignore
import { AddressesRequestBuilderNavigationMetadata, type AddressesRequestBuilder } from './addresses/index.js';
// @ts-ignore
import { AffiliatesRequestBuilderNavigationMetadata, AffiliatesRequestBuilderRequestsMetadata, type AffiliatesRequestBuilder } from './affiliates/index.js';
// @ts-ignore
import { BackfillsRequestBuilderNavigationMetadata, type BackfillsRequestBuilder } from './backfills/index.js';
// @ts-ignore
import { CallsRequestBuilderNavigationMetadata, CallsRequestBuilderRequestsMetadata, type CallsRequestBuilder } from './calls/index.js';
// @ts-ignore
import { ChargepointsRequestBuilderNavigationMetadata, ChargepointsRequestBuilderRequestsMetadata, type ChargepointsRequestBuilder } from './chargepoints/index.js';
// @ts-ignore
import { ChargerdefinitiondocumentsRequestBuilderNavigationMetadata, type ChargerdefinitiondocumentsRequestBuilder } from './chargerdefinitiondocuments/index.js';
// @ts-ignore
import { ChargerdefinitionsRequestBuilderNavigationMetadata, ChargerdefinitionsRequestBuilderRequestsMetadata, type ChargerdefinitionsRequestBuilder } from './chargerdefinitions/index.js';
// @ts-ignore
import { CompanyregistrationsRequestBuilderNavigationMetadata, type CompanyregistrationsRequestBuilder } from './companyregistrations/index.js';
// @ts-ignore
import { ContractsRequestBuilderNavigationMetadata, ContractsRequestBuilderRequestsMetadata, type ContractsRequestBuilder } from './contracts/index.js';
// @ts-ignore
import { ConversionfactorsRequestBuilderNavigationMetadata, ConversionfactorsRequestBuilderRequestsMetadata, type ConversionfactorsRequestBuilder } from './conversionfactors/index.js';
// @ts-ignore
import { CustomersRequestBuilderNavigationMetadata, CustomersRequestBuilderRequestsMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { DocumentsRequestBuilderNavigationMetadata, type DocumentsRequestBuilder } from './documents/index.js';
// @ts-ignore
import { FetchRequestBuilderNavigationMetadata, type FetchRequestBuilder } from './fetch/index.js';
// @ts-ignore
import { IngestsRequestBuilderNavigationMetadata, type IngestsRequestBuilder } from './ingests/index.js';
// @ts-ignore
import { LedgersRequestBuilderNavigationMetadata, LedgersRequestBuilderRequestsMetadata, type LedgersRequestBuilder } from './ledgers/index.js';
// @ts-ignore
import { LocationsRequestBuilderNavigationMetadata, LocationsRequestBuilderRequestsMetadata, type LocationsRequestBuilder } from './locations/index.js';
// @ts-ignore
import { MeRequestBuilderRequestsMetadata, type MeRequestBuilder } from './me/index.js';
// @ts-ignore
import { MessagesRequestBuilderNavigationMetadata, type MessagesRequestBuilder } from './messages/index.js';
// @ts-ignore
import { MeteringpointsRequestBuilderNavigationMetadata, type MeteringpointsRequestBuilder } from './meteringpoints/index.js';
// @ts-ignore
import { OauthconnectionsRequestBuilderNavigationMetadata, type OauthconnectionsRequestBuilder } from './oauthconnections/index.js';
// @ts-ignore
import { PayoutsRequestBuilderNavigationMetadata, PayoutsRequestBuilderRequestsMetadata, type PayoutsRequestBuilder } from './payouts/index.js';
// @ts-ignore
import { RegistrationsRequestBuilderNavigationMetadata, RegistrationsRequestBuilderRequestsMetadata, type RegistrationsRequestBuilder } from './registrations/index.js';
// @ts-ignore
import { ServiceprovidersettingsRequestBuilderNavigationMetadata, ServiceprovidersettingsRequestBuilderRequestsMetadata, type ServiceprovidersettingsRequestBuilder } from './serviceprovidersettings/index.js';
// @ts-ignore
import { TransactionsRequestBuilderNavigationMetadata, TransactionsRequestBuilderRequestsMetadata, type TransactionsRequestBuilder } from './transactions/index.js';
// @ts-ignore
import { type VersionRequestBuilder, VersionRequestBuilderRequestsMetadata } from './version/index.js';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type RequestAdapter } from '@microsoft/kiota-abstractions';
// @ts-ignore
import { FormParseNodeFactory, FormSerializationWriterFactory } from '@microsoft/kiota-serialization-form';
// @ts-ignore
import { JsonParseNodeFactory, JsonSerializationWriterFactory } from '@microsoft/kiota-serialization-json';
// @ts-ignore
import { MultipartSerializationWriterFactory } from '@microsoft/kiota-serialization-multipart';
// @ts-ignore
import { TextParseNodeFactory, TextSerializationWriterFactory } from '@microsoft/kiota-serialization-text';

/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface ApiClient extends BaseRequestBuilder<ApiClient> {
    /**
     * The accounts property
     */
    get accounts(): AccountsRequestBuilder;
    /**
     * The addresses property
     */
    get addresses(): AddressesRequestBuilder;
    /**
     * The affiliates property
     */
    get affiliates(): AffiliatesRequestBuilder;
    /**
     * The backfills property
     */
    get backfills(): BackfillsRequestBuilder;
    /**
     * The calls property
     */
    get calls(): CallsRequestBuilder;
    /**
     * The chargepoints property
     */
    get chargepoints(): ChargepointsRequestBuilder;
    /**
     * The chargerdefinitiondocuments property
     */
    get chargerdefinitiondocuments(): ChargerdefinitiondocumentsRequestBuilder;
    /**
     * The chargerdefinitions property
     */
    get chargerdefinitions(): ChargerdefinitionsRequestBuilder;
    /**
     * The companyregistrations property
     */
    get companyregistrations(): CompanyregistrationsRequestBuilder;
    /**
     * The contracts property
     */
    get contracts(): ContractsRequestBuilder;
    /**
     * The conversionfactors property
     */
    get conversionfactors(): ConversionfactorsRequestBuilder;
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
    /**
     * The documents property
     */
    get documents(): DocumentsRequestBuilder;
    /**
     * The fetch property
     */
    get fetch(): FetchRequestBuilder;
    /**
     * The ingests property
     */
    get ingests(): IngestsRequestBuilder;
    /**
     * The ledgers property
     */
    get ledgers(): LedgersRequestBuilder;
    /**
     * The locations property
     */
    get locations(): LocationsRequestBuilder;
    /**
     * The me property
     */
    get me(): MeRequestBuilder;
    /**
     * The messages property
     */
    get messages(): MessagesRequestBuilder;
    /**
     * The meteringpoints property
     */
    get meteringpoints(): MeteringpointsRequestBuilder;
    /**
     * The oauthconnections property
     */
    get oauthconnections(): OauthconnectionsRequestBuilder;
    /**
     * The payouts property
     */
    get payouts(): PayoutsRequestBuilder;
    /**
     * The registrations property
     */
    get registrations(): RegistrationsRequestBuilder;
    /**
     * The serviceprovidersettings property
     */
    get serviceprovidersettings(): ServiceprovidersettingsRequestBuilder;
    /**
     * The transactions property
     */
    get transactions(): TransactionsRequestBuilder;
    /**
     * The version property
     */
    get version(): VersionRequestBuilder;
}
/**
 * Instantiates a new {@link ApiClient} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createApiClient(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    const serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry;
    const parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry;
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    
    if (parseNodeFactoryRegistry.registerDefaultDeserializer) {
        parseNodeFactoryRegistry.registerDefaultDeserializer(JsonParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(TextParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(FormParseNodeFactory, backingStoreFactory);
    }
    
    if (serializationWriterFactory.registerDefaultSerializer) {
        serializationWriterFactory.registerDefaultSerializer(JsonSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(TextSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(FormSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(MultipartSerializationWriterFactory);
    }
    
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<ApiClient>(requestAdapter, pathParameters, ApiClientNavigationMetadata, undefined);
}
/**
 * Uri template for the request builder.
 */
export const ApiClientUriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiClientNavigationMetadata: Record<Exclude<keyof ApiClient, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    accounts: {
        requestsMetadata: AccountsRequestBuilderRequestsMetadata,
        navigationMetadata: AccountsRequestBuilderNavigationMetadata,
    },
    addresses: {
        navigationMetadata: AddressesRequestBuilderNavigationMetadata,
    },
    affiliates: {
        requestsMetadata: AffiliatesRequestBuilderRequestsMetadata,
        navigationMetadata: AffiliatesRequestBuilderNavigationMetadata,
    },
    backfills: {
        navigationMetadata: BackfillsRequestBuilderNavigationMetadata,
    },
    calls: {
        requestsMetadata: CallsRequestBuilderRequestsMetadata,
        navigationMetadata: CallsRequestBuilderNavigationMetadata,
    },
    chargepoints: {
        requestsMetadata: ChargepointsRequestBuilderRequestsMetadata,
        navigationMetadata: ChargepointsRequestBuilderNavigationMetadata,
    },
    chargerdefinitiondocuments: {
        navigationMetadata: ChargerdefinitiondocumentsRequestBuilderNavigationMetadata,
    },
    chargerdefinitions: {
        requestsMetadata: ChargerdefinitionsRequestBuilderRequestsMetadata,
        navigationMetadata: ChargerdefinitionsRequestBuilderNavigationMetadata,
    },
    companyregistrations: {
        navigationMetadata: CompanyregistrationsRequestBuilderNavigationMetadata,
    },
    contracts: {
        requestsMetadata: ContractsRequestBuilderRequestsMetadata,
        navigationMetadata: ContractsRequestBuilderNavigationMetadata,
    },
    conversionfactors: {
        requestsMetadata: ConversionfactorsRequestBuilderRequestsMetadata,
        navigationMetadata: ConversionfactorsRequestBuilderNavigationMetadata,
    },
    customers: {
        requestsMetadata: CustomersRequestBuilderRequestsMetadata,
        navigationMetadata: CustomersRequestBuilderNavigationMetadata,
    },
    documents: {
        navigationMetadata: DocumentsRequestBuilderNavigationMetadata,
    },
    fetch: {
        navigationMetadata: FetchRequestBuilderNavigationMetadata,
    },
    ingests: {
        navigationMetadata: IngestsRequestBuilderNavigationMetadata,
    },
    ledgers: {
        requestsMetadata: LedgersRequestBuilderRequestsMetadata,
        navigationMetadata: LedgersRequestBuilderNavigationMetadata,
    },
    locations: {
        requestsMetadata: LocationsRequestBuilderRequestsMetadata,
        navigationMetadata: LocationsRequestBuilderNavigationMetadata,
    },
    me: {
        requestsMetadata: MeRequestBuilderRequestsMetadata,
    },
    messages: {
        navigationMetadata: MessagesRequestBuilderNavigationMetadata,
    },
    meteringpoints: {
        navigationMetadata: MeteringpointsRequestBuilderNavigationMetadata,
    },
    oauthconnections: {
        navigationMetadata: OauthconnectionsRequestBuilderNavigationMetadata,
    },
    payouts: {
        requestsMetadata: PayoutsRequestBuilderRequestsMetadata,
        navigationMetadata: PayoutsRequestBuilderNavigationMetadata,
    },
    registrations: {
        requestsMetadata: RegistrationsRequestBuilderRequestsMetadata,
        navigationMetadata: RegistrationsRequestBuilderNavigationMetadata,
    },
    serviceprovidersettings: {
        requestsMetadata: ServiceprovidersettingsRequestBuilderRequestsMetadata,
        navigationMetadata: ServiceprovidersettingsRequestBuilderNavigationMetadata,
    },
    transactions: {
        requestsMetadata: TransactionsRequestBuilderRequestsMetadata,
        navigationMetadata: TransactionsRequestBuilderNavigationMetadata,
    },
    version: {
        requestsMetadata: VersionRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
